import { graphClient } from '../../graph-client'
import { GET_GIFT_TYPES } from './gql'
import type { Get } from './types'

class GiftTypeService {
  async get({
    take,
    skip,
    typeFilterDate,
    dateInitial,
    dateFinal,
    active,
  }: Get.Input) {
    const request = await graphClient.request<Get.Output>(GET_GIFT_TYPES, {
      take,
      skip: take * skip,
      typeFilterDate,
      dateInitial,
      dateFinal,
      active,
    })

    return request?.getGiftsTypes
  }
}

export const giftTypeService = new GiftTypeService()
